import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-[#E0E0D9] bg-[#F3F3EF]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="font-serif-display text-4xl md:text-5xl font-light leading-none">
              ProBeauty Connect
            </div>
            <p className="mt-6 max-w-md text-[#525252] leading-relaxed">
              A curated marketplace connecting licensed beauty professionals with
              salon owners hiring. We take your data — and your trust — seriously.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-meta text-[11px] uppercase tracking-[0.25em] text-[#8A8A8A] mb-5">
              Legal
            </div>
            <ul className="space-y-3">
              <li><Link to="/" className="text-[#525252] hover:text-[#C6826D] transition-colors">Legal Home</Link></li>
              <li><Link to="/privacy-policy" className="text-[#525252] hover:text-[#C6826D] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-[#525252] hover:text-[#C6826D] transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy-choices" className="text-[#525252] hover:text-[#C6826D] transition-colors">Privacy Choices</Link></li>
              <li><Link to="/delete-account" className="text-[#525252] hover:text-[#C6826D] transition-colors">Delete Account</Link></li>
              <li><Link to="/support" className="text-[#525252] hover:text-[#C6826D] transition-colors">Contact & Support</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-meta text-[11px] uppercase tracking-[0.25em] text-[#8A8A8A] mb-5">
              Contact
            </div>
            <ul className="space-y-3">
              <li><a href="mailto:privacy@probeauty.app" className="text-[#525252] hover:text-[#C6826D] transition-colors">privacy@probeauty.app</a></li>
              <li><a href="mailto:legal@probeauty.app" className="text-[#525252] hover:text-[#C6826D] transition-colors">legal@probeauty.app</a></li>
              <li><a href="mailto:support@probeauty.app" className="text-[#525252] hover:text-[#C6826D] transition-colors">support@probeauty.app</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#E0E0D9] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono-meta text-[11px] uppercase tracking-[0.2em] text-[#8A8A8A]">
            © 2026 ProBeauty Connect · All rights reserved
          </div>
          <div className="font-mono-meta text-[11px] uppercase tracking-[0.2em] text-[#8A8A8A]">
            Processed in the United States
          </div>
        </div>
      </div>
    </footer>
  );
};
